<template>
  <div class="rework">
    <h3>申请维修</h3>
    <div class="tableData">
      <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">

        <el-table :data="orderList" style="width: 100%" :header-cell-style="{ 
        background:'rgba(71,71,71)',color:'#ffffff'}">
          <el-table-column prop="date" label="选择" width="80" align="center">
            <template slot-scope="scope">
              <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.$index}} {{scope.row.cid}}</el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="维修数量" width="180" align="center">
            <template slot-scope="scope">
              <el-input-number size="mini" v-model="scope.row.num" :min="1" :max="scope.row.number" label="描述文字">
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="可维修数量" width="120" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.number}}</div>
            </template>
          </el-table-column>
          <el-table-column label="订单产品" align="center" width="440">
            <template slot-scope="scope">
              <div class="products">
                <img :src="scope.row.photos"
                  alt="">
                <div v-html="scope.row.name"></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="包装清单" align="center" width="540">
            <template slot-scope="scope">
              <div class="packing">无</div>
            </template>
          </el-table-column>
          <el-table-column label="购买数量" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.approvalStatus}}</div>
            </template>
          </el-table-column>
          <el-table-column label="单价" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.realprice}}</div>
            </template>
          </el-table-column>
          <el-table-column label="小计" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.realprice*scope.row.approvalStatus}}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
    </div>
    <div class="formData">
      <el-row>

        <el-form :model="formInline" label-width="130px" class="demo-form-inline" ref="ruleForm" :rules="rules">
          <el-col :span="18">
            <el-form-item label="服务类型：">
              <div>返修</div>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="维修原因：" prop="reason">
              <el-select v-if="repairReason" v-model="formInline.reason" placeholder="请选择">
                <el-option v-for="item in repairReason" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="问题描述：" prop="remarks">
              <el-input type="textarea" :rows="12" maxlength="200" placeholder="请输入问题描述（最多200字）"
                v-model="formInline.remarks">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="图片信息："  prop="picRules">
              <el-upload class="avatar-uploader" name="files" :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar"> -->
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="upload_img">
                <p>为了帮助您更好的解决问题，请上传图片</p>
                <p>最多可上传10张图片，支持bmf，gif，jpg，png，jpeg等格式文件</p>
              </div>
              <div class="upload_img">
                <div v-for="(item,index) in imgUpload" :key="index"><img :src="item" alt=""><i
                    @click="deleteUpload(index)" class="el-icon-error"></i></div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span='24'>

            <h3>确认信息</h3>
          </el-col>
          <el-col :span="18">
            <el-form-item label="申请票据：" prop="invoice">
             <div class="method">
               <el-select v-model="formInline.invoice"  placeholder="请选择票据">
                 <el-option label="不需要发票" value="0"></el-option>
                 <el-option label="需要发票" value="1"></el-option>
               </el-select>
             </div>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="返回方式：" prop="mailMethod">
              <div class="method">
                <el-select v-model="formInline.mailMethod"  placeholder="请选择返回方式">
                  <el-option label="到付" value="0"></el-option>
                  <el-option label="寄付" value="1"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="收货区域：" prop="receivingArea">
              <!-- <el-select v-model="formInline.receivingArea" placeholder="请输入收货区域">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select> -->
			 <el-cascader v-if="areaData" 
			  					ref="cascader"
			  					size="small"
			  					v-model="formInline.receivingArea"
			  					:options="areaData"
			  					@change="handleChange($event)"
			  					style="display:block;"
			  ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="详细地址：" prop="address">
              <el-input v-model="formInline.address" placeholder="请输入详细地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="联系人姓名：" prop="contactName">
              <div class="userName">
                <el-input v-model="formInline.contactName" placeholder="请输入联系人姓名"></el-input>

              </div>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="联系方式：" prop="contactTel">
              <div class="user">
                <el-input v-model="formInline.contactTel" placeholder="请输入联系方式"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <el-button type="primary" @click="onSubmit('ruleForm')">提交</el-button>
            </el-form-item>
          </el-col>
		 
        </el-form>
      </el-row>
    </div>
  </div>
</template>
<script>
import { showorderDetail, getDictData ,applyRework ,reworkArea} from '@/api/xunyou'
export default {
  data() {
    return {
      imgUpload: [],
      imageUrl: '',
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: true,
      orderData:'',
      formInline: {
        contactName: '',
        contactTel: '',
        serviceType: 2,
        remarks: '',
        paymentProof: '',
        mailMethod: '',
		receivingAreaId:[],
        receivingArea: [],
        reason:'',
        address:'',
        repairReason:[],
		invoice:''
      },
      orderInfoList: JSON.parse(sessionStorage.getItem("orderDetail")) || [],
      orderList: [],
      rules: {
        contactName: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        contactTel: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        receivingArea: [
          { required: true, message: '请选择收货区域', trigger: 'change' },
        ],
        mailMethod: [
          { required: true, message: '请选择返回方式', trigger: 'change' },
        ],
        reason: [
          { required: true, message: '请选择维修原因', trigger: 'change' },
        ],
		invoice:[
          { required: true, message: '请选择是否需要票据', trigger: 'blur' },
        ],
		picRules:[
			 { required: true, message: '请上传图片', validator: this.picValidator }
		],
		remarks:[
			{ required: true, message: '请填写问题描述', trigger: 'blur' },
		]
      },
	  areaData:[],
	  goodsactive:[]      // 选中的商品
    }
  },
  components: {},
  created() {
    this.getOrderDetail()
    this.backReason()
	this.getAreaDetail()
  },
  mounted() { },
  methods: {
	  picValidator(rule, value, callback) {
	      if (this.imgUpload.length === 0) {
	        callback(new Error('校验：请上传图片')) // 一定要写 callBack() 验证完成时调用的回调函数 https://github.com/yiminghe/async-validator
	      } else {
	        callback()
	      }
	    },
	 
	handleChange(value) {
				console.log(value);
				console.log(value[2]);
				const checkedNode =  this.$refs["cascader"].getCheckedNodes();
				this.formInline.receivingAreaId = checkedNode[0].pathLabels;
				this.formInline.receivingArea= value[2];
				    console.log( checkedNode[0].data.label ) ;  //获取当前点击节点的label值
				    console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
			
			},
//   获取区域信息
    getAreaDetail() {
      reworkArea().then(res => {
        console.log(res)
        if (res.code == 0) {
          this.areaData = res.data
        }else{
			console.log('获取区域信息异常');
		}
      })
    },
    //   查询订单详情
    getOrderDetail() {
      showorderDetail({ oid: this.orderInfoList.oid }).then(res => {
        console.log(res)
        if (res.code == 0) {
          this.orderData = res.rows[0]
          this.orderList = res.rows[0].bxyCommodityList
          this.orderList.forEach(item=>{
            this.$set(item,'num',1)
          })
		  console.log('列表',  this.orderList);
        }else{
					console.log(res.msg);
				}
      })
    },
    backReason() {
      getDictData({
        key: 'sys_repair_reason'
      }).then(res => {
        if (res.code == 0) {
          console.log(res)
          this.repairReason = res.data
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    handleCheckedCitiesChange(value) {
		console.log(value);
		this.goodsactive = value
      // console.log(this.checkedCities)
			console.log(this.orderList);
	
			
			
			
			
    },
    onSubmit(ruleForm) {
		if(this.goodsactive.length<1){
			this.$message({
			  type: 'info',
			  message: '请选择返修商品'
			})
			
		}
		
      this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let newArr = {
              ...this.formInline,
              oid:this.orderData.oid,
              orderNumber:this.orderData.orderNumber,
              paymentProof:this.imgUpload,
              bXyAfterOrderGoodsList:'',
			    uid:JSON.parse(localStorage.getItem("userdata")).userId
            }
            let newList = []
			console.log(this.orderList);
			console.log(this.goodsactive);
            this.orderList.forEach(item=>{
					for(var i =0; i< this.goodsactive.length; i++){
						if(item.id == this.goodsactive[i] ){
							newList.push({goodsId:item.id,goodsNum:item.num})
						}
					}
			})
            console.log(this.orderList);
            newArr.bXyAfterOrderGoodsList = JSON.stringify(newList)   
			applyRework(newArr).then(res=>{
              if(res.code == 0 ){
				  console.log(res);
					this.$message({
					  type: 'success',
					  message: res.msg
					})
					setTimeout(()=>{
						this.$router.push(`/reworkList`)
					},2000)
					
			  }else{
				  this.$message({
				    type: 'info',
				    message: res.msg
				  })
			  }
            })
          } 
        });
    },
    handleAvatarSuccess(res, file) {
      console.log(res.url)
      if (this.imgUpload.length > 10) {
        this.$message.error('最多可上传10张图片!');
      } else {
        this.imgUpload.push(res.url)
      }
    },
    deleteUpload(index) {
      this.imgUpload.splice(index, 1)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/bmf' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error('上传图片只支持bmf，gif，jpg，png，jpeg等格式文件!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return isJPG && isLt2M;
    }
  }
};
</script>

<style scoped lang="less">
.rework {
  padding: 20px;
  width: 90%;
  margin: 0 auto;

  h3 {
    font-size: 16px;
    margin: 0 0 60px 0;
  }
}

/deep/ .el-table th>.cell {
  border-right: 1px solid #ffffff;
}

.products {
  display: flex;
  align-items: center;
  padding: 0 30px;

  img {
    width: 100px;
    height: auto;
  }

  div {
    text-align: left;
    margin-left: 20px;
  }
}

.packing {
  padding: 0 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed gray;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.upload_img {
  margin-top: 10px;

  p {
    font-size: 14px;
    line-height: 25px;
    color: gray;
  }
}

.el-select {
  width: 60%;
}

/deep/ .el-checkbox__label {
  display: none;
}

.method::after {
  content: '因客户原因导致的退货/维修可能承担运费和服务费';
  margin-left: 10px;
  color: #f56c6c;
}

.user:after {
  content: '提交申请后，客服将尽快与您联系，请保持手机畅通';
  margin-left: 10px;
  color: #f56c6c;
}

.user /deep/ .el-input {
  display: inline;
}

.userName {

  width: 50%;
}

.user /deep/ .el-input__inner {
  width: 50%;
}

.upload_img {
  display: flex;
  flex-wrap: wrap;

  div {
    position: relative;
  }

  i {
    position: absolute;
    right: 14px;
    color: #ffffff;
    top: 0;
  }

  img {
    width: 150px;
    height: 150px;
    margin-right: 10px;
  }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/rework/index.vue